<template>
  <div>
    <div>
      <el-table :cell-style='styleCenter' :data="invoiceList" :header-cell-style='styleCenter' style="width: 100%"
                @selection-change="handleSelectionChange" @row-click='openDialog'>
        <el-table-column label="发票抬头" prop="invoiceTitle" width="200"></el-table-column>
        <el-table-column label="发票类型" prop="invoiceType" width="200">
          <template slot-scope="scope">
            {{ scope.row.invoiceType == 1 ? '个人普票（电子版）' : (scope.row.invoiceType == 2 ? '企业普票（电子版）' : '企业专票') }}
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="money" width="200"></el-table-column>
        <el-table-column label="发票状态" prop="invoiceStatus" width="200">
          <template slot-scope="scope">
            {{ scope.row.invoiceStatus == 1 ? '已提交' : '已开票' }}
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom-page-div">
        <el-pagination :current-page="page.currentPage" :page-size="page.pageSize"
                       :page-sizes="[10, 20, 30, 50]"
                       :total="page.total" layout="total, sizes, prev, pager, next, jumper"
                       @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="platformDialog" title="申请发票">
      <div>
        <span>开票金额：</span>
        <span>￥{{ showForm.money }}</span>
      </div>
      <el-divider></el-divider>
      <el-checkbox-group v-model="showForm.invoiceType" :max="1" disabled>
        <el-checkbox :true-label='1' label="个人普票（电子版）"></el-checkbox>
        <el-checkbox :true-label='2' label="企业普票（电子版）"></el-checkbox>
        <el-checkbox :true-label='3' label="企业专票"></el-checkbox>
      </el-checkbox-group>
      <el-divider></el-divider>
      <el-form ref="ruleForm" :model="showForm" :rules="rules" disabled label-width="120px" status-icon>
        <el-form-item label="发票抬头：" prop="invoiceTitle">
          <el-input v-model="showForm.invoiceTitle"></el-input>
        </el-form-item>
        <el-form-item v-if="showForm.invoiceType!=1" label="纳税人识别号：" prop="taxpayerNum">
          <el-input v-model="showForm.taxpayerNum"></el-input>
        </el-form-item>
        <el-form-item label="收件人手机号：" prop="recipientsPhone">
          <el-input v-model="showForm.recipientsPhone"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" prop="email">
          <el-input v-model="showForm.email"></el-input>
        </el-form-item>
        <template v-if="showForm.invoiceType!=1">
          <el-form-item label="注册公司地址：" prop="companyAddress">
            <el-input v-model="showForm.companyAddress"></el-input>
          </el-form-item>
          <el-form-item label="开户行：" prop="openingBank">
            <el-input v-model="showForm.openingBank"></el-input>
          </el-form-item>
          <el-form-item label="银行账号：" prop="bankAccount">
            <el-input v-model="showForm.bankAccount"></el-input>
          </el-form-item>
          <el-form-item label="注册公司电话：" prop="companyPhone">
            <el-input v-model="showForm.companyPhone"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="发票备注：" prop="invoiceNote">
          <el-input v-model="showForm.invoiceNote"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:center">
        <el-button @click="platformDialog=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getList} from '@/api/biz/auction/invoiceInfo'

export default {
  name: 'InvoiceHistoryView',
  data() {
    return {
      styleCenter: {'text-align': 'center'},
      invoiceList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      platformDialog: false,
      showForm: {},
      rules: {
        invoiceTitle: [{required: true, message: '请输入发票抬头', trigger: 'change'}],
        taxpayerNum: [{required: true, message: '请输入纳税人识别号', trigger: 'change'}],
        recipientsPhone: [{required: true, message: '请输入收件人手机号', trigger: 'change'}],
        email: [{required: true, message: '请输入电子邮箱', trigger: 'change'},
          {type: 'email', message: '邮箱格式不正确，请重新输入', trigger: 'blur'}],
      }
    }
  },
  computed: {...mapGetters(["userInfo"])},
  created() {
    this.queryData(this.page);
  },
  methods: {
    openDialog(row) {
      console.log('row', row)
      this.showForm = row;
      this.platformDialog = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    queryData(page) {
      getList(page.currentPage, page.pageSize, {bidderId: this.userInfo.user_id}).then(res => {
        const data = res.data.data;
        this.invoiceList = data.records;
        this.page.total = data.total;
      })
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.queryData(this.page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.queryData(this.page);
    },
  },
}
</script>

<style>

</style>
